import { Skeleton } from '@/components/ui/skeleton'
import { LONG_PRESS_THRESHOLD } from '@/constants'
import { cn } from '@/lib/utils'
import { usePrimaryPage } from '@/PageManager'
import { HugeiconsIcon } from '@hugeicons/react'
import { LoginCircle01Icon } from '@hugeicons/core-free-icons'
import { useMemo, useRef, useState } from 'react'
import LoginDialog from '../LoginDialog'
import { SimpleUserAvatar } from '../UserAvatar'
import BottomNavigationBarItem from './BottomNavigationBarItem'
import { unwrappedSignerAtom, useCurrentPubkey } from '@/atoms/session'
import { useCurrentProfile } from '@/atoms/profile'
import { useAtomValue } from 'jotai'

export default function AccountButton() {
  const { navigate, current, display } = usePrimaryPage()
  const profile = useCurrentProfile()
  const pubkey = useCurrentPubkey()
  const signer = useAtomValue(unwrappedSignerAtom)
  const [loginDialogOpen, setLoginDialogOpen] = useState(false)
  const active = useMemo(
    () => current === 'profile' && display && !!pubkey,
    [display, current, pubkey]
  )
  const pressTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  return (
    <>
      <BottomNavigationBarItem
        onPointerDown={handlePointerDown}
        onPointerUp={handlePointerUp}
        active={active}
      >
        {signer && pubkey ? (
          profile ? (
            <SimpleUserAvatar
              user={pubkey}
              className={cn('w-7 h-7', active ? 'ring-primary ring-1' : '')}
            />
          ) : (
            <Skeleton className={cn('w-7 h-7 rounded-full', active ? 'ring-primary ring-1' : '')} />
          )
        ) : (
          <HugeiconsIcon icon={LoginCircle01Icon} />
        )}
      </BottomNavigationBarItem>
      <LoginDialog open={loginDialogOpen} setOpen={setLoginDialogOpen} />
    </>
  )

  function handlePointerDown() {
    pressTimerRef.current = setTimeout(() => {
      setLoginDialogOpen(true)
      pressTimerRef.current = null
    }, LONG_PRESS_THRESHOLD)
  }

  function handlePointerUp() {
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current)
      if (signer && pubkey) navigate('profile', { pubkey })
      else setLoginDialogOpen(true)
      pressTimerRef.current = null
    }
  }
}
